<template>
  <div class="input">
    <h2 class="input__title">{{ title }}</h2>
    <input
      class="input__input"
      :class="{ 'input__input--active': active }"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
      ref="input"
    />
    <p class="input__subline">{{ subline }}</p>
  </div>
</template>

<script>
export default {
  mixins: [],
  props: {
    title: String,
    placeholder: String,
    value: String | Number,
    subline: String,
    disabled: {
      default: true,
      type: Boolean,
    },
    active: Boolean,
  },
  emits: {
    input: String | Number,
    select: undefined,
  },
  mounted() {
    if (this.active) this.$refs.input.focus();
  },
  updated() {
    if (this.active) this.$refs.input.focus();
  },
  watch: {
    active(isActive) {
      if (isActive) this.$refs.input.focus();
      else this.$refs.input.blur();
    },
  },
};
</script>

<style scoped>
.input {
  margin-bottom: 3rem;
}
.input__title {
  color: #6c8290;
  font-size: 32px;
  margin-bottom: 0.5rem;
}
.input__input {
  background: rgba(0, 0, 0, 0.2);
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  color: #6c8290;
  font-size: 32px;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  width: 100%;
}

.input__input:focus {
  outline: none;
}
.input__input::selection {
  color: rgba(0, 0, 0, 1);
  background: white;
}
.input__input--active {
  box-shadow: 0 0 6px 4px rgba(255, 255, 255, 0.5);
  border-color: white;
}

.input__subline {
  color: white;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationInput.vue